'use strict';

import angular from 'angular';
import EditController from './edit.controller';

export default angular.module('updateServerApp.firmwares.edit', [])
  .controller('FirmwaresEditController', EditController)
  .name;



// WEBPACK FOOTER //
// ./client/app/firmwares/edit/index.js